import { FavouriteDataColumn } from 'app/components/favourite-layout/favourite/common/favourite-interfaces';
import React from 'react';
import styles from './../case-table-view.scss';

export function CaseTableViewHeaderComponent({ columns, columnWidths, tableWidth, containerRef, handleScroll }: {
  columns: Partial<FavouriteDataColumn>[];
  tableWidth?: number;
  columnWidths?: number[];
  containerRef?: React.RefObject<HTMLDivElement | null>;
  handleScroll: (event: React.UIEvent<HTMLDivElement, UIEvent>) => void;
}) {

  if (!columns?.length || !columnWidths?.length) {
    return null;
  }

  return (
    <div ref={containerRef} className={styles.headerContainer} onScroll={handleScroll}>
      <div className={styles.tableRow} style={{ width: tableWidth }}>
        {columns.map((column, index) => (
          <div key={index} className={styles.tableHead} style={{ width: columnWidths?.[index] }}>
            <div className={styles.header}> {column.shortText} </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export const CaseTableViewHeader = React.memo(CaseTableViewHeaderComponent);
